import { createSlotsContext } from "@grandvisionhq/slots";
const [RxConfiguratorSlotsProvider, useRxConfiguratorSlots] = createSlotsContext({
  displayName: "RxConfiguratorSlotsContext"
});
export {
  RxConfiguratorSlotsProvider,
  useRxConfiguratorSlots
};
//# sourceMappingURL=context.js.map
